query GetCharityContactInvitations(
  $charityId: ID!
  $status: CharityContactInvitationListStatusEnum!
) {
  charityContactInvitations(charityId: $charityId, status: $status) {
    id
    status
    addresseeType
    email
    firstName
    lastName
    portalRole
    invitationSentAt
    invitedBy {
      id
      name
    }
    emailVerification {
      domain
      score
      shouldBlock
      fetchedAt
      notes
      riskLevel
      riskLevelNotes
      verificationStatus
    }
  }
}
